import theme from "theme";

export const headerHideTransition = "top 240ms ease-in-out";
export const mobileHeaderHeight = 65;
export const desktopHeaderHeight = 93;
// Asset Details
export const assetDetailsTabHeight = 48;

export const colors = {
  greyishModalBackground: "#E5E5E5",
  greyHelpLink: "#999999",
  greyBackground: "#E1E1E3",
  warning: "#d39a2f",
};

export const REGULAR_CHART_COLOR_LIST = [
  "#4E3ACA",
  "#7559d5",
  "#9579e0",
  "#b299eb",
  "#cebbf5",
  "#e9ddff",
];

export const circleIconSize = {
  small: "2rem",
  medium: "4rem",
  big: "5.3rem",
};

export const defaultFontFamily = "Open Sans, sans-serif";

export const linkPurpleStyles = {
  color: theme.custom.palette.purple.main,
  fontSize: "inherit",
  "&:hover": {
    color: theme.custom.palette.purple.main,
    textDecoration: "underline",
  },
};

export const menuItemPurpleStyles = {
  "&.MuiListItem-root.Mui-focusVisible": {
    backgroundColor: theme.custom.palette.purple.light,
  },
  "&.MuiListItem-root.Mui-selected": {
    backgroundColor: theme.custom.palette.purple.main,
    color: theme.custom.palette.gray.light,
  },
  "&:hover": {
    backgroundColor: theme.custom.palette.purple.light,
  },
};

export const textFieldPurpleStyles = {
  "& label.Mui-focused": {
    color: theme.custom.palette.purple.main,
  },
  "&:hover label": {
    color: theme.custom.palette.purple.main,
  },
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: theme.custom.palette.purple.main,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.custom.palette.purple.main,
    },
  },
};

export const thinBorderStyles = {
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
};
